import React from 'react';
import { Box, Header, Icons, variables } from '@generationtux/component-library';
import { listCategories } from '../../../data/listCategories';
import { scrollTop } from '../../../utils/utils';
import styled from 'styled-components';

const BoxLink = styled(Box)`
  cursor: pointer;
  &:hover {
    div:last-child {
      color: ${props => variables(props).textPrimary};
      polygon {
        fill: ${props => variables(props).textPrimary};
      }
      line {
        stroke: ${props => variables(props).textPrimary};
      }
    }
  }
`;

const GalleryHeader = ({ activeCollection, modelToggle, setModelToggle, setActiveCollection }) => {
  const { name } = listCategories.filter(x => x.name === activeCollection)[0];
  return (
    <>
      <Box backgroundColor="white" mb={1}>
        <BoxLink
          display="flex"
          alignItems="center"
          p={3}
          onClick={() => {
            scrollTop();
            setActiveCollection(null);
          }}
        >
          <Box>
            <Header type={2} size={5}>
              {name}
            </Header>
          </Box>
          <Box display="flex" justifyContent="flex-end" alignItems="center" style={{ flexGrow: 1 }}>
            <Icons.X />
          </Box>
        </BoxLink>
      </Box>
    </>
  );
};

export default GalleryHeader;
